import React from "react";
import { motion } from "framer-motion";
import OurMission from '../../assets/OurMission1.png';
import OurVision from '../../assets/OurVision.png';

const OurVisionMission = () => {
  return (
    <>
      <div className="flex flex-col lg:flex-row items-center justify-center gap-8 p-4">
        <div className="max-w-4xl px-4 md:px-6 lg:px-8 text-center lg:text-left">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A]">
            Our Mission
          </h2>
          <p className="mt-6 text-base md:text-lg lg:text-xl leading-6 md:leading-8 text-[#1F2937]">
            We aim to provide accurate and timely research, analysis, and recommendations to investors, enabling them to make informed decisions and achieve their financial goals.
          </p>
        </div>
        <motion.img
          src={OurMission}
          className="h-[22rem] w-[22rem]"
          alt="Our Mission"
          animate={{ y: [0, -10, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
        />
      </div>

      <div className="flex flex-col-reverse lg:flex-row items-center justify-center gap-8 p-4">
        <motion.img
          src={OurVision}
          className="h-[18rem] w-[18rem]"
          alt="Our Vision"
          animate={{ y: [0, -10, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
        />
        <div className="max-w-4xl px-4 md:px-6 lg:px-8 text-center lg:text-left">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A]">
            Our Vision
          </h2>
          <p className="mt-6 text-base md:text-lg lg:text-xl leading-6 md:leading-8 text-[#1F2937]">
            To empower investors with knowledge and security through unbiased, transparent, and reliable research.
          </p>
        </div>
      </div>
    </>
  );
};

export default OurVisionMission;
